import { useParams } from "react-router-dom";
import { getPerformedJobFields, getNow } from "../utils";
import Form from "./Form";
import { useDataContext } from "../contexts";

export default function PerformedJobAdd({ callback, user }) {
  const { submissionId } = useParams();
  const { memberUsers, jobs } = useDataContext();

  const performedJobFields = getPerformedJobFields(user, memberUsers, jobs);

  return (
    <Form
      path="performed-jobs"
      fields={performedJobFields}
      submitCallback={callback}
      initialValues={{
        user: user.id,
        datePerformed: getNow(),
        submission: submissionId,
      }}
    />
  );
}
